<div class="d-flex w-100 h-100 justify-content-center align-items-center bg--primary">
    <span class="loader d-flex justify-content-center align-items-center">
        <img class="volta-icon" src="assets/images/volta-icon-transparent_50px.webp"/>
    </span>
</div>